import { render, staticRenderFns } from "./setpaypwd.vue?vue&type=template&id=6fb8616d&scoped=true&"
import script from "./setpaypwd.vue?vue&type=script&lang=js&"
export * from "./setpaypwd.vue?vue&type=script&lang=js&"
import style0 from "./setpaypwd.vue?vue&type=style&index=0&id=6fb8616d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8616d",
  null
  
)

export default component.exports